<!--
  评价
  lovi 2020-07-06
-->
<template>
  <div class="w100 childRoute-wrapper">
    <van-nav-bar
      :title="$t('life.orderEvaluation')"
      :fixed="true"
      left-arrow
      @click-left="navBarBack"
    />
    <div class="scroll-wrapper">
      <div class="evaluate">
        <div class="title">
          <div class="info">
            <div class="image"><img :src="data.image" /></div>
            <h3>{{ data.shop_name }}</h3>
          </div>
          <van-checkbox v-model="isAnonymity" checked-color="#FE7800">
            {{ $t("life.anonymousEvaluation") }}
          </van-checkbox>
        </div>
        <van-field
          v-model="evaluate"
          rows="3"
          autosize
          type="textarea"
          maxlength="200"
          :placeholder="$t('life.enterEvaluation')"
          show-word-limit
        />
        <div class="upload-wrap">
          <!-- 添加图片列表 -->
          <template v-if="imgList.length">
            <div
              class="item-list"
              v-for="(item, index) in imgList"
              :key="index"
            >
              <div class="img-wrap">
                <img :src="item.show" />
                <i class="icon-delete" @click="delImage(index)"></i>
              </div>
            </div>
          </template>

          <!-- 添加图片 -->
          <div class="item-list" v-if="imgList.length < 3">
            <van-uploader :after-read="addImage">
              <van-icon name="plus" />
            </van-uploader>
          </div>
        </div>
      </div>
    </div>
    <div class="button-wrap button-fixed">
      <van-button
        block
        type="primary"
        @click="_uploadimages"
        :loading="btnLoading"
      >
        {{ $t("life.submitReview") }}
      </van-button>
    </div>
  </div>
</template>

<script>
export default {
  props: ["data"],
  meta: {
    service: false
  },
  components: {},
  data() {
    return {
      btnLoading: false,
      isAnonymity: false,
      evaluate: "",
      imgList: []
    };
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {
    navBarBack() {
      // 返回事件
      this.$emit("update:evaluateFlag", false);
    },
    addImage(file) {
      // 添加图片
      let vm = this;
      let obj = {};
      obj.show = file.content;
      obj.base64 = file.content.split("base64,")[1];
      vm.imgList.push(obj);
      console.log("addImage", vm.imgList);
    },
    delImage(index) {
      // 删除当前图片
      let vm = this;
      vm.imgList.splice(index, 1);
      console.log("delImage", vm.imgList, index);
    },
    _uploadimages() {
      // 提交反馈
      let vm = this;
      if (vm.evaluate == "") {
        vm.$toast(vm.$t("life.enterEvaluation"));
        return;
      }
      let params = {};
      params.images = vm.imgList;
      // params.encryption = 1;
      params.order_id = vm.data.order_id;
      params.shop_id = vm.data.shop_id;
      params.comments = vm.evaluate;
      params.is_hidden = vm.isAnonymity ? 0 : 1;
      vm.btnLoading = true;
      vm.$post("/app/file/uploadimages", params, { alert: true }).then(res => {
        console.log("uploadimages", res);
        vm.btnLoading = false;
        vm.$toast(res.msg);
        if (res.code == 0) {
          vm.navBarBack();
          vm.$emit("getEvaluate");
        }
      });
    }
  },
  watch: {}
};
</script>

<style lang="less" scoped>
.scroll-wrapper {
  bottom: 65px;
  background: #f4f4f4;
}
.button-fixed {
  background: #f4f4f4;
}
.evaluate {
  position: relative;
  padding: 0 15px;
  background: #fff;
  .title {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 10px 0;
    line-height: 1;
    border-bottom: 1px solid #efefef;
    .info {
      flex: 1;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .image {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 10px;
        width: 32px;
        height: 32px;
        border-radius: 4px;
        overflow: hidden;
        img {
          max-width: 100%;
          max-height: 100%;
        }
      }
      h3 {
        font-size: 14px;
        font-weight: 400;
      }
    }
    /deep/.van-checkbox {
      .van-checkbox__icon {
        width: 16px;
        height: 16px;
        font-size: 16px;
      }
      .van-checkbox__label {
        margin-left: 5px;
        line-height: 1;
      }
    }
  }
  /deep/.van-cell {
    padding: 10px 0;
    &::after {
      content: normal;
    }
    .van-field__word-limit {
      margin-top: 10px;
      height: 40px;
      line-height: 40px;
    }
  }
}
.upload-wrap {
  position: absolute;
  left: 15px;
  bottom: 10px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  .item-list {
    margin-left: 12px;
    &:first-child {
      margin-left: 0;
    }
    .van-icon-plus {
      width: 38px;
      height: 38px;
      text-align: center;
      line-height: 38px;
      font-size: 16px;
      color: #d7d7d7;
      border: 1.1px solid #d7d7d7;
    }
    .img-wrap {
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      height: 40px;
      width: 40px;
      border: 1.1px solid #d7d7d7;
      .icon-delete {
        position: absolute;
        top: -10px;
        right: -10px;
        width: 20px;
        height: 20px;
        background: url("~@/assets/images/public/icon-delete.png");
        background-size: 100% 100%;
      }
      img {
        max-height: 100%;
        max-width: 100%;
      }
    }
  }
}
</style>
